import iconMCC from "../images/icon/mcc.png";
import iconCompanyVisit from "../images/icon/company-visit.png";
import iconSeminar from "../images/icon/seminar.png";
import iconJobExpo from "../images/icon/job-expo.png";
import iconMCCFill from "../images/icon/mcc-fill.png";
import iconCompanyVisitFill from "../images/icon/company-visit-fill.png";
import iconSeminarFill from "../images/icon/seminar-fill.png";

import imageAnon from "../images/seminar/anonymous.png";
import imageHapsari from "../images/seminar/hapsari.jpeg";
import imageWilly from "../images/seminar/willy.jpg";
import imageYenita from "../images/seminar/yenita.jpeg";
import imageYenny from "../images/seminar/yenny.jpg";

export const lang = {
  auth: {
    forgotPassword: {
      body: {
        input:
          "Enter email associated with your account. We’ll send you a link so you can update your password.",
        sent: "We’ve sent a link to your email so you can change your password. Please check your email.",
      },
    },
  },
  homepage: {
    hero: {
      title: {
        we: "We want ",
        you: "YOU",
        part: " to be a part of it!",
      },
      slogan: "#SeekTheBiggerYou",
    },
    event: {
      title: "Our Events",
    },
    info: {
      left: {
        what: "What is",
        weekend: "Weekend",
        career: "Career Expo?",
      },
      right: {
        p1: "Established in 2021, Weekend Career Expo by UI Women in Business aims to not only help graduates and students find the right job, but also to help employers acquire top-notch human resources.",
        p2: "Based on the market research we’ve conducted, we found that many students and graduates face the same issues when looking for a job. These issues consist of lack of knowledge in:",
        p3: [
          "career planning;",
          "how to network in the professional world;",
          "how to make their CV standout among other applicants; and",
          "how to nail a job interview.",
        ],
        p4: "Hence, as a community which focuses on career development, UI Women in Business facilitates graduates and students by holding the Weekend Career Expo. It is an event which not only helps our target segments find the right job, but also boosts their employability and savviness in the ever so competitive professional world.",
      },
    },
  },
  about: {
    history: {
      title: "The History of UI WIB",
      p1: "Universitas Indonesia Women in Business (UIWIB) is a community initiated by women at Universitas Indonesia (UI) for women at UI and the society. We aim to provide a deeper understanding of various career opportunities and insights on gender issues surrounding women to female students at UI. In order for us to achieve that vision, we are guided by the following missions which are to empower, connect, and grow the women community at UI.",
      p2: "At UIWIB, we believe that our core duty is to empower the women community at UI through career and gender education. We aspire to provide an extensive understanding of the variety of obstacles that women face. We want to help them navigate their way through adulthood and continuously emphasize the belief that gender should not hinder women from pursuing their dream careers. We also aim to connect like-minded women students in UI. We strive to become a hub between our members and the women alumni of UI to increase access towards events or mentorship opportunities. Lastly, our programs are designed to grow the skills and experience of our members and women at UI, both personally and professionally.",
      p3: "We hope that as part of UIWIB and through our working programs, our members and the greater women community both in and outside UI will gain deeper knowledge about gender-related issues and access to sharpening their skills in relation to a variety of career choices. In this generation, we aim to give positive impacts through active participation in the working programs to the board members as well as the greater women community.",
    },
    misson: {
      title: "UI WCE’s Vision & Mission",
      vision:
        "Preparing graduates and students to enter the world of work and encourage them to utilize this platform in understanding job and career path development",
      mission:
        "Providing information on various job vacancies offered by institutions, universities, and companies and creating a platform for interaction between the academic world and the business world",
    },
    team: {
      title: {
        first: "Meet the",
        second: "team",
        third: "!",
      },
      p1: "Senior Advisor",
      p2: "Project Consultant",
      p3: "Board of Directors",
    },
    event: {
      title: "Our Event Sequences",
    },
  },
  events: {
    mcc: {
      title: "Mini Case Competition",
      show: true,
      icon: iconMCC,
      iconFill: iconMCCFill,
      date: "4 - 31 May 2023",
      location: "Zoom (Online)",
      link: "/mini-case-competition",
      description:
        "Mini Case Competition is a nationwide event that will give the participants a chance to train their capability of problem solving and critical thinking in order to overcome the case that is provided by our collaborator. This event features targeted training sessions designed to equip both competition participants and members of the public with the skills necessary for success. The top five competitors will advance to the semi-finals, where they will have the opportunity to present their final pitch to a panel of esteemed judges. The winner of the competition will be announced during the main event.",
    },
    companyVisit: {
      title: "Company Visit",
      show: true,
      icon: iconCompanyVisit,
      iconFill: iconCompanyVisitFill,
      date: "31 May 2023",
      location: "Pinhome HQ, SCBD",
      link: "/company-visit",
      description:
        "Company Visit is an event which allows Weekend Career Expo 2023 participants to visit the targeted company directly. This event aims to give participants knowledge regarding the company vividly and give them a chance to experience and see what is inside the professional circumstances of working. It is hoped that participants will be motivated to further explore career options in the target fields and companies,  have the opportunity to network with professionals in the industry, as well as preparing to be a future applicant candidate of the company.",
    },
    seminar: {
      title: "Seminar",
      show: true,
      icon: iconSeminar,
      iconFill: iconSeminarFill,
      date: "1 July 2023",
      location: "Ganara Art Space, Plaza Indonesia",
      link: "/seminar",
      description:
        "Weekend Career Expo’s seminar offers an insightful and engaging discussion regarding tips on how to excel in all parts of the job application process, such as CV, cover letter, and interviews. This session will be conducted by experienced recruiters and talent acquisition experts. The seminar aims to provide first-hand tips that would enlighten and encourage participants to polish their job applications in order to attain their dream job.",
    },
    jobExpo: {
      title: "Job Expo",
      show: true,
      icon: iconJobExpo,
      date: "1 - 20 July 2023",
      location: "Online (Website)",
      link: "/job-expo",
      description:
        "An interactive showcase of the various career opportunities offered by our partner companies, especially catered and curated for the university students participating in the event.",
    },
  },
  seminar: {
    locations: {
      desc: "During the main event, seminar participants and visitors can access the location in some ways",
      route: [
        {
          title: "KRL [TRANSIT]",
          desc: "Depok/Bogor line → Transit in Manggarai → Cikarang Line → drop off at Sudirman/BNI Kota → MRT to Dukuh Atas BNI → Bundaran HI Station",
        },
        {
          title: "KRL [NO TRANSIT]",
          desc: "Depok/Bogor line (Jakarta Kota) → drop off at Gondangdia Station → online/public transportation to Plaza Indonesia",
        },
      ],
    },
    sessions: [
      {
        title: "Ask a Sister - Women in Tech",
        speakers: [
          {
            name: "To be Revealed",
            role: "",
            image: imageAnon,
          },
          {
            name: "Hapsari Muthi Amira",
            role: "Head of Data Analytics at GoTo",
            image: imageHapsari,
          },
        ],
      },
      {
        title: "Company Session",
        speakers: [
          {
            name: "Willy Hambali",
            role: "Chief Operating Officer of Aladin Bank",
            image: imageWilly,
          },
          {
            name: "Yenny Laksana",
            role: "Director of Operations of NEWLAB+",
            image: imageYenny,
          },
        ],
      },
      {
        title: "Ask a Sister x L'Oréal Master Class - The Art of Communication",
        speakers: [
          {
            name: "Yenita Oktora",
            role: "Chief Human Resource Officer at L'Oréal",
            image: imageYenita,
          },
        ],
      },
    ],
    rundown: [
      {
        time: "09.10",
        title: "Opening",
      },
      {
        time: "09.15",
        title: "Woman in Tech",
      },
      {
        time: "10.00",
        title: "QNA Session",
      },
      {
        time: "10.25",
        title: "Closing",
      },
      {
        time: "10.40",
        title: "Aladin Company presentation",
      },
      {
        time: "11:20",
        title: "QNA Session",
      },
      {
        time: "11:40",
        title: "NEWLAB+ Company presentation",
      },
      {
        time: "12:20",
        title: "QNA Session",
      },
      {
        time: "12:40",
        title: "Ishoma + Lunch",
      },
      {
        time: "13:15",
        title: "L'Oréal Masterclass",
      },
      {
        time: "14:00",
        title: "QNA Session",
      },
      {
        time: "14:20",
        title: "Mini Case Competition Winner Announcement",
      },
      {
        time: "14:25",
        title: "Door prize Announcement",
      },
    ],
  },
  footer: {
    center: {
      p1: "© Universitas Indonesia Women in Business (UIWIB)",
      p2: "UIWIB is an independent student-run organization at Universitas Indonesia. ",
      p3: "All Rights Reserved.",
    },
    right: {
      instagram: "@uiwomeninbusiness",
      linkedin: "Universitas Indonesia Women in Business",
      tiktok: "@uiwomeninbusiness",
      email: "womeninbusiness.ui@gmail.com",
    },
  },
};
